import { api } from '@/lib/api-client';
import type { BanModel, BanDto } from '@/models/bans';
import { hoursToMilliseconds, numberToDuration } from '@/utils/tools';

export const BanService = {
  async createBan(playerId: string, updates: Partial<BanModel>) {
    const params = {
      player_id: +playerId,
      reason_code: updates.reason?.id,
      description: updates.description,
      duration: numberToDuration(hoursToMilliseconds(updates.duration ?? 0)),
      feature_codes: updates.features,
    };
    const response = await api.post<Omit<BanModel, 'id'>>('/v1/ban', params);
    return response.data;
  },

  async updateBan(id: string, updates: Partial<BanModel>) {
    await api.put(`/v1/ban/${id}`, {
      description: updates.description,
    });
    return true;
  },

  async liftBan(id: string, reason: string) {
    // const response = await fakeUpdateBan(id, {
    await api.put<BanDto>(`/v1/ban/${id}/status/lift`, {
      reason,
    });
    return true;
  },

  async deleteBan(id: string) {
    await api.delete(`/v1/ban/${id}`);
    return true;
  },
};
